import { UserMinus } from 'lucide-react';
import { ChecklistBoard } from './components/ChecklistBoard';

const OffboardingPage = () => (
  <ChecklistBoard
    kind="offboarding"
    title="Offboarding"
    description="Checklists for departing employees — access revocation, equipment return, and final paperwork."
    crumbLabel="Offboarding"
    icon={UserMinus}
  />
);

export default OffboardingPage;
